/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import type { BaseShowOptions, GeetestOptions } from '../typings';
import { BaseCaptcha } from './base';

export const GeetestLocalMap: Record<string, string> = {
  en: 'en',
  'en-US': 'en',
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
  'zh-MY': 'zh-cn',
  'ja-JP': 'ja',
  'ru-RU': 'ru',
  'es-ES': 'es',
  'vi-VN': 'vi',
  'tr-TR': 'tr',
  'pt-BR': 'pt-pt',
  'fr-FR': 'fr',
  'th-TH': 'th',
  'id-ID': 'id',
  'ko-KR': 'ko',
  'vi-vn': 'vi',
  'kk-KZ': '',
  'fil-PH': '',
  'uk-UA': '',
  'hi-IN': '',
};

export class Geetest extends BaseCaptcha {
  apiMethod: GeetestOptions['geetStep1Request'];
  cbHandler: GeetestOptions['cbHandler'];
  bindId: string;
  constructor(options: GeetestOptions) {
    super(options);
    this.bindId = '';
    this.key = 'geecaptcha';
    this.defaultLang = 'en';
    this.apiMethod = options.geetStep1Request;
    this.cbHandler = (obj: any) => {};
  }

  setLang(lang: string) {
    this.lang = GeetestLocalMap[lang || this.defaultLang];
  }

  refresh() {
    if (this.captcha && this.captcha.reset) {
      this.captcha.reset();
    }
  }

  destroy() {
    if (this.captcha) {
      this.captcha.destroy();
    }
  }

  initialize() {}

  async preLoadGeet(id: string) {
    this.bindId = id;

    try {
      const res: any = await this.apiMethod();
      const { result: data } = res;
      if (!data || !data.success) {
        throw new Error('Init Error');
      }
      /* eslint-disable @typescript-eslint/no-this-alias */
      const self = this;

      const defaultOpt = {
        gt: data.gt,
        challenge: data.challenge,
      };
      const opt = {
        // 以下配置参数来自极验SDK
        offline: !data.success,
        new_captcha: data.newCaptcha,
        lang: self.lang,
        product: 'bind',
        hideSuccess: false,
        hideClose: false,
        hideRefresh: true,
      };

      const callbackFn = (geetCaptcha: any) => {
        geetCaptcha.appendTo(`#${id}`);
        geetCaptcha.onSuccess(() => {
          const result = geetCaptcha.getValidate();
          self?.cbHandler({
            type: self.key,
            geetest_challenge: result.geetest_challenge,
            geetest_seccode: result.geetest_validate,
            geetest_validate: result.geetest_seccode,
          });
        });
        geetCaptcha.onError(
          (error: { error_code: string; message?: string }) => {
            console.warn(`[${this.key}] ${error}`);
            const code = error.error_code.split('_')[1];

            if (+code > 100) {
              geetCaptcha.destroy();
              self.cbHandler({ type: self.key, fallback: true });
            } else {
              geetCaptcha.reset();
              self.cbHandler({
                type: self.key,
                error: error.message || `[${this.key}] InValid`,
              });
            }
          },
        );
      };

      return new Promise((rs) => {
        try {
          window.initGeetest({ ...opt, ...defaultOpt }, (captchaObj: any) => {
            if (!captchaObj.onFail) {
              // geetest 网络崩溃降级
              rs(false);
            } else {
              self.captcha = captchaObj;
              callbackFn(captchaObj);
              captchaObj.onReady(() => {
                rs(true);
              });
            }
          });
        } catch (e) {
          console.error(e);
          rs(false);
        }
      });
    } catch (e) {
      console.info('加载 geetest 失败');
      console.warn(`[${this.key}] ${e}`);
      return false;
    }
  }

  async show(options: BaseShowOptions) {
    this.cbHandler = options.callback;

    if (!this.captcha) return null;

    try {
      this.captcha.verify();
    } catch (e) {
      console.error(e);
    }

    return this.captcha;
  }
}
